<template>
  <div
    class="home"
  >
    <!-- <HomeSide></HomeSide> -->
    <HomeSwiper />
    <HomeCar />
    <!-- <DiySwiper /> -->
    <HomeTechnology />
    <HomeStore />
    <HomeServer />
  </div>
</template>

<script>
// import HomeSide from './components/side.vue'
import HomeSwiper from './components/Swiper.vue'
import HomeCar from './components/car.vue'
import DiySwiper from './components/diyswiper.vue'
import HomeTechnology from './components/technology.vue'

import HomeStore from './components/store.vue'
import HomeServer from './components/server.vue'

export default {
  name: 'HomeView',
  components: {
    // HomeSide,
    HomeSwiper,
    HomeCar,
    DiySwiper,
    HomeTechnology,
    HomeStore,
    HomeServer
  },
  data() {
    return {}
  },
  mounted() {
    document.title = 'SUNRA，Ultra high-end intelligent electric vehicles'
  },
  watch: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.home {}
.section {
  width: 100%;
  min-width: 960px;
  // height: calc(100vh - 60px);
  height: calc(100vh - 60px);
}
</style>
